import { Button, ButtonProps } from '@mui/material'
import React, { ReactElement, useState } from 'react'

import useAccessTokenAndShopId from '../../hooks/useAccessTokenAndShopId/useAccessTokenAndShopId'
import { useCopyToNewInspectionMutation } from '../../redux/api/inspectionApi'
import { LoadingBackdrop } from '../SharedUI/LoadingBackdrop'
import SelectDialog from './SelectDialog'

type Props = ButtonProps & {
  repairOrderId: string
}

// this component is shared between main app and dvi
function AddInspectionButton({
  repairOrderId,
  ...buttonProps
}: Props): ReactElement {
  const { accessToken, shopId } = useAccessTokenAndShopId()
  const [dialogOpen, setDialogOpen] = useState<boolean>(false)
  const [copyToNewInspection] = useCopyToNewInspectionMutation()
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false)
  const copyInspection = async (inspectionId: string, techId: string) => {
    setIsSubmitting(true)
    await copyToNewInspection({
      authorization: accessToken,
      copyInspectionRequest: {
        inspection: inspectionId,
        shop: shopId,
        repairOrder: repairOrderId,
        tech: techId || undefined
      }
    })
    setIsSubmitting(false)
    setDialogOpen(false)
  }

  return (
    <>
      {isSubmitting && <LoadingBackdrop />}
      {dialogOpen && (
        <SelectDialog
          selectCallback={copyInspection}
          handleClose={() => setDialogOpen(false)}
        />
      )}
      <Button {...buttonProps} onClick={() => setDialogOpen(true)} />
    </>
  )
}

export default AddInspectionButton
